import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('properties-documents', storeModule.createStoreModule('properties-documents'))
